/**
 * Created by Z179603 on 7/17/2016.
 */
angular.module('cvsApp')
    .factory('RequestServiceHelper', ['commonServiceHelper', '$q',
        function (commonServiceHelper, $q) {
            var help = {
                wcmService: function (moduleName) {
                    var date = new Date();
                    var currentYear = date.getFullYear();
                    var currentMonth =convertToTwoDigit(date.getMonth() + 1);
                    var currentDay = convertToTwoDigit(date.getDate());

                    var hour = convertToTwoDigit(date.getHours());
                    var minute = convertToTwoDigit(date.getMinutes());
                    var second = convertToTwoDigit(date.getSeconds());

                    var timeStamp = currentYear + '-' + currentMonth + '-' + currentDay + 'T' + hour + ':' + minute + ':' + second;

                    var tid = cvsUtility.queryMap.tokenId;
                    var tokenType = (!tid) ? 'Guest' : 'Login';

                    var requestJson = {request:{
                        tokenID:tid,
                        tokenType:tokenType,
                        apiKey:cvsUtility.queryMap.apikey,
                        componentName: moduleName,
                        timestamp:timeStamp}};

                   function convertToTwoDigit (number) {
                        return (number < 10) ? '0' + number : number;
                    }
                    var deferred = $q.defer();
                    commonServiceHelper.getWCMService(requestJson).then(
                        function (response) {
                            if(response !=null && response.response &&  response.response.details){
                                deferred.resolve(response.response.details);
                            }else{
                                deferred.reject(response);
                            }

                        }, function () {
                            deferred.reject('Error');
                        }
                    );
                    return deferred.promise;
                },
                specialtyConfig: function(configKeyReq){
                    var deferred = $q.defer();
                    var requestJson={};
                    var request={
                            "apiKey":cvsUtility.queryMap.apikey,
                            "tokenId":cvsUtility.queryMap.tokenId,
                            "configurationRequest":{
                                configKey: configKeyReq ? configKeyReq : ["PAYMENT-PUB-KEY"]
                            }
                    };
                    requestJson.request=request;
                    commonServiceHelper.getSpecialtyConfigService(requestJson).then(
                        function (response) {
                            if(response !=null && response.response &&  response.response.header && response.response.header.statusCode && response.response.header.statusCode=="0000"){
                                deferred.resolve(response.response);
                            }else{
                                deferred.reject(response);
                            }

                        }, function () {
                            deferred.reject('Error');
                        }
                    );
                    return deferred.promise;
                }
            };

            return help;

        }]);
